import { FOOT, KNEE } from "../../utils/constants";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useQuery } from "../shared/RouterHelpers";
import { useState } from "react";
import NoAuthApi from "../../api/NoAuthApi";
import Player from "@vimeo/player";
import React from "react";
import toast from "react-hot-toast";
import translations from "../../utils/translations.json"

const TrainingPage = () => {
  const query = useQuery();
  const navigate = useNavigate();

  const footVideoId = "938352926";
  const kneeVideoId = "936682354";

  const { type } = useParams();
  const [error, setError] = useState();

  const [displayText, setDisplayText] = useState("");

  const getTranslation = (key) => {
    return translations[key][query.get("lang")] || translations[key]['en'];
  };

  useEffect(() => {
    let videoLink = "";
    // set video based on device type
    switch (type.toLocaleLowerCase()) {
      case FOOT:
        videoLink = footVideoId;
        break;
      case KNEE:
        videoLink = kneeVideoId;
        break;
      default:
        toast.error("No training available for device type: " + type);
        navigate("/");
    }
    const options = {
      id: videoLink,
      loop: false,
      controls: true,
    };
    const player = new Player("trainingVideo", options);
    player.on("ended", updateTrainingStatus);

    // Handle test environment for Brandon's UI testing
    const metas = document.getElementsByTagName("meta");
    if (
      Array.from(metas).some((meta) => meta.getAttribute("name") === "ui-test")
    ) {
      setTimeout(() => updateTrainingStatus(), 7000);
    }

    setDisplayText(getTranslation('training_instructions'));
  }, []);

  const updateTrainingStatus = async () => {
    const errorText =
      "Error updating training status, please contact College Park support";
    const serialNumber = query.get("serial_number");
    const token = query.get("token");
    if (serialNumber && token) {
      try {
        await NoAuthApi.post(
          "has-completed-training",
          { serial_number: serialNumber },
          { headers: { Authorization: "Bearer " + token } }
        );
        try {
          // this function is used by the mobile app to close the training window,
          // but isn't defined here, hence the disable for eslint
          // eslint-disable-next-line no-undef
          InvokeTrainingComplete();
        } catch {
          // pass
        }
        return;
      } catch {
        setError(errorText);
      }
    }
    setError(getTranslation('training_error'));
  };

  return (
    <div className="text-center bg-white fill-height">
      {error ? (
        <div className="text-danger">{error}</div>
      ) : (
        <>
          <div id="trainingVideo" className="video"></div>
          <h3 className="m-2 video-text fw-bold">{displayText}</h3>
        </>
      )}
    </div>
  );
};

export default TrainingPage;
